module.exports = __webpack_public_path__ + "media/images/loghi/FIP_logo_FIP_vert_bn_neg-ef8c941fe4247107a7ad32a969044782.png";